import type { ProfileResource } from '@medplum/core'
import { TypographyDetail, TypographySubtle } from '@seen/ui'
import type { JSX } from 'react'
import { EditButton } from '#src/components/patient/detail-content/contact-tab/EditButton.tsx'
import { useIsReadOnly } from '#src/hooks/useIsReadOnly.ts'

interface NameDisplayProps {
  name: string
  profile: ProfileResource
}

export function NameDisplay({ name, profile }: NameDisplayProps): JSX.Element {
  const isReadOnly = useIsReadOnly()
  return (
    <div className="group flex items-center gap-1">
      <div className="grid flex-1">
        <TypographyDetail className="leading-none font-semibold text-zinc-950">
          Name
        </TypographyDetail>
        <TypographySubtle className="py-1.5">{name}</TypographySubtle>
      </div>
      {!isReadOnly && (
        <div className="invisible flex group-hover:visible">
          <EditButton profile={profile} field="name" />
        </div>
      )}
    </div>
  )
}
